// Libs
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Component
import JobDetail, { Props } from '../components/jobs-panel/JobDetail'

// Selectors and Actions
import { selectedSamplingPoints$ } from 'hfty-soil-jobs'
import { areaPerAsset$ } from 'fc-assets'
import { editSoilJob } from 'hfty-soil-jobs-dom'
import {
  // Selectors
  selectedSoilTestFilter$,
  hoverSamplingPoint$,
  imageryLayersToggled$,
  selectedFieldId$,

  // Actions
  toggleImageryLayers,
  selectSoilTestFilter,
  toggleHoverPoint,
  selectJobFeature,
} from 'hfty-map'
import jobDetail$ from '../selectors/jobDetail'
import { editPoint$ } from 'hfty-sampling-point'
import samplingPointOperator from 'hfty-operator-sampling-point'
import { gridsOfJob$ } from 'hfty-grid'

const mapStateToProps = (state: Object, props: Object): Props => {
  const { selectedJob, gridData } = props
  const selectedFieldId = selectedFieldId$(state)
  const areaPerAsset = areaPerAsset$(state)
  const area = areaPerAsset[selectedFieldId]

  return {
    samplingPoints: selectedSamplingPoints$(state),
    filter: selectedSoilTestFilter$(state),
    selectedSamplingPoint: hoverSamplingPoint$(state),
    jobDetail: jobDetail$(state),
    imageryLayersToggled: imageryLayersToggled$(state),
    selectedJob,
    grid: gridsOfJob$(state),
    gridData,
    area,
    operation: editPoint$(state),
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      onHover: toggleHoverPoint,
      onSelectFilter: selectSoilTestFilter,
      onEditJob: editSoilJob,
      selectJobFeature,
      onClickImageryLayer: toggleImageryLayers,
      cancelOperation: samplingPointOperator.actionCreators.cancelOperation,
    }, dispatch),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(JobDetail)
